/*
 * @Author: zhu.huijun
 * @Date: 2021-08-19 15:27:40
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2022-01-05 17:34:48
 */
import React, { useEffect, useState, useMemo, forwardRef } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { renderFormItems, AcqAttrCodes, acquisitionItems } from '@/utils';

const DeviceFormItem = forwardRef(props => {
  const { extraFormItems = [], addToLast, initialValue, modelKey, form, dispatch } = props;
  const { getFieldDecorator, resetFields } = form;
  const [attrGroup, setAttrGroup] = useState([]); // 设备采集信息
  const [rentalTypeGroup, setRentalTypeGroup] = useState([]);
  const [acqValue, setAcqValue] = useState(); // 选择的设备

  useEffect(() => {
    dispatch({ // 获取 设备采集列表 属性信息 CPE_ACQUISITION_TYPE、BSNL_DEVICE_RENTAL_TYPE
      type: 'business/qryAttrInfoBsnl',
      payload: {
        attrCodes: `${AcqAttrCodes.CPE_ACQUISITION_TYPE},${AcqAttrCodes.RENTAL_TYPE}`,
      },
      modelName: modelKey,
    }).then((res = []) => {
      res.forEach((it = {}) => {
        if (it.attrCode === AcqAttrCodes.CPE_ACQUISITION_TYPE) {
          setAttrGroup(it.attrValueDtoList || []);
        }
        if (it.attrCode === AcqAttrCodes.RENTAL_TYPE) {
          setRentalTypeGroup(it.attrValueDtoList || []);
        }
      });
    });
  }, []);

  // 设备选择
  const handleAcqTypeChange = value => {
    resetFields([AcqAttrCodes.RECEIPT_NUMBER, AcqAttrCodes.FRANCHISEE, AcqAttrCodes.RENTAL_TYPE]);
    setAcqValue(value);
  };

  const getFormItems = () => {
    let items = acquisitionItems(attrGroup, rentalTypeGroup, acqValue, initialValue, handleAcqTypeChange);
    if (!isEmpty(extraFormItems)) {
      if (addToLast) {
        items = [
          ...items,
          ...extraFormItems,
        ];
      } else {
        items = [
          ...extraFormItems,
          ...items,
        ];
      }
    }
    return items;
  };

  const formItems = useMemo(() => getFormItems(), [extraFormItems, addToLast, attrGroup, rentalTypeGroup, acqValue, initialValue]);

  return (
    <>
      {renderFormItems(formItems, getFieldDecorator)}
    </>
  );
});

export default connect()(DeviceFormItem);
